module.exports = "pegasus/assets/email1-logo2.png";